// Older browser support fix
// https://github.com/johndatserakis/koa-vue-notes-api/issues/1
import 'es6-promise/auto'

import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import BootstrapVue from 'bootstrap-vue'
//import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

//import vueAwesomeCountdown from 'vue-awesome-countdown'
//Vue.use(vueAwesomeCountdown, 'vac')

import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Bangkok')

import VueCountdownTimer from 'vuejs-countdown-timer'
Vue.use(VueCountdownTimer)

import datePicker from 'vue-bootstrap-datetimepicker'
Vue.use(datePicker)

import VueSelect from 'vue-cool-select'
Vue.use(VueSelect, {
    theme: 'bootstrap' // or 'material-design'
})

import vSelectMenu from 'v-selectmenu'
Vue.use(vSelectMenu)

import Clipboard from 'v-clipboard'
Vue.use(Clipboard)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
Vue.use(Loading, {
    // loader: 'bars',
    color: '#048cfc',
    'background-color': 'silver',
    height: 128,
    width: 128,
})

// set language to EN
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

locale.use(lang)

// import DataTables and DataTablesServer separately
import { DataTables, DataTablesServer } from 'vue-data-tables'
Vue.use(DataTables)
Vue.use(DataTablesServer)

// import DataTables and DataTablesServer together
import VueDataTables from 'vue-data-tables'
Vue.use(VueDataTables)


import Toasted from 'vue-toasted'
import 'vue-toasted/dist/vue-toasted.min.css'
Vue.use(Toasted, {
    theme: 'bubble',
    position: 'top-center',
    duration: 2300
})

import VueGoogleCharts from 'vue-google-charts'
Vue.use(VueGoogleCharts)

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: '#ADE027',
    failedColor: '#F43D41',
    thickness: '3px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
})

import axios from 'axios'

//import './assets/css/app.scss' // app styles

// The following two interceptor blocks are strictly for
// attaching the top-loading bar to all axios requests and
// stoping the bar on all responses.
// Add a request interceptor

axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:4000'

// ✅ รวม Progress + Attach JWT ไว้ใน request interceptor ตัวเดียว
axios.interceptors.request.use(function (config) {
    router.app.$Progress.start()

    // ✅ ใช้ key ที่ถูกจริงของคุณ
    var token = localStorage.getItem('accessToken')

    if (token) {
        config.headers = config.headers || {}
        config.headers.Authorization = 'Bearer ' + token
    }

    return config
}, function (error) {
    router.app.$Progress.fail()
    return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
    router.app.$Progress.finish()
    return response
}, function (error) {
    router.app.$Progress.fail()
    return Promise.reject(error)
})

Vue.config.productionTip = true

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')